const qldAssessmentQuestions = [
                {
                    id: 1,
                    name: 'What is the name of the <b>Legislative Act<b> that relates to health and safety in Queensland workplaces?',
                    subtitle: 'Tick (✓) the correct option. There is one (1) correct answer.',
                    options: [
                        'Occupational Health and Safety Act 2002',
                        'Work Health and Safety Act 2011',
                        'Workplace Health and Safety Act 2000',
                        'Working Safely Act 2012',
                    ],
                    type: 'options',
                    answer: 'Work Health and Safety Act 2011'
                },
                {
                    id: 2,
                    name: 'What other documents, besides the Legislative Act, can provide guidance and information about work health and safety in Queensland?',
                    subtitle: 'Tick (✓) the correct options. There are three (3) correct answers.',
                    options: [
                        'Work Health and Safety Regulation 2011',
                        'Workplace Health and Safety Queensland safety alerts',
                        'Codes of Practice',
                        'Workplace Health and Safety Regulation 2002',
                    ],
                    type: 'options',
                    answers: [
                        'Work Health and Safety Regulation 2011',
                        'Workplace Health and Safety Queensland safety alerts',
                        'Codes of Practice',
                    ]
                },
                {
                    id: 3,
                    name: 'When at work, a <b>worker<b> has a legal <b>duty<b> to take reasonable care __________.',
                    subtitle: 'Tick (✓) the correct options. There are two (2) correct answers.',
                    options: [
                        'For their own health and safety',
                        'To do things that won’t affect the health and safety of others',
                        'Of their belongings',
                        'To ensure tasks are completed on time',
                    ],
                    type: 'options',
                    answers: [
                        'For their own health and safety',
                        'To do things that won’t affect the health and safety of others',
                    ]
                },
                {
                    id: 4,
                    name: 'Who has a <b>‘duty of care’<b> under the Queensland Work Health and Safety Act 2011 on a construction site?',
                    partALabel: 'Part A',
                    subtitle: 'Tick (✓) the correct options. There are three (3) correct answers.',
                    partBLabel: 'Part B',
                    partBQuestion: 'Explain why these duties are important when working on a construction site.',
                    assessorGuideHtml: `<p>Student response should demonstrate a basic understanding that duties under the WHS Act cover everyone on site.</p><p><b>Example response:</b> Ensures everyone on site keeps the workplace safe and prevents incidents happening.</p>`,
                    options: [
                        'The company who runs the construction site',
                        'Sub-contractors',
                        'Workers engaged in work on the construction site',
                        'People walking past the site',
                    ],
                    type: 'options',
                    answers: [
                        'The company who runs the construction site',
                        'Sub-contractors',
                        'Workers engaged in work on the construction site',
                    ]
                },
                {
                    id: 5,
                    name: 'Under the Queensland Work Health and Safety Act 2011, a <b>worker<b> who carries out construction work for a Person Conducting a Business or Undertaking <b>(PCBU)<b> can be __________.',
                    partALabel: 'Part A',
                    subtitle: 'Tick (✓) the correct options. There are three (3) correct answers.',
                    partBLabel: 'Part B',
                    partBQuestion: 'Explain why it is important that the Queensland Work Health and Safety Act 2011 includes all of these types of workers.',
                    assessorGuideHtml: `<p>Student response should demonstrate a basic understanding that the WHS Act covers everyone on site, regardless of how they are employed.</p><p><b>Example response:</b> Because all workers must keep the workplace safe, no matter how they are employed.</p>`,
                    options: [
                        'An individual who does work in their own business',
                        'An emergency services officer',
                        'A work-experience student',
                        'A sub-contractor',
                    ],
                    type: 'options',
                    answers: [
                        'An individual who does work in their own business',
                        'A work-experience student',
                        'A sub-contractor',
                    ]
                },
                {
                    id: 6,
                    name: 'A <b>PCBU<b> under the Queensland Work Health and Safety Act 2011 __________.',
                    subtitle: 'Tick (✓) the correct option. There is one (1) correct answer.',
                    options: [
                        'Is a volunteer association',
                        'Has a duty of care to ensure the health and safety of all workers',
                        'Is an elected member of a local government',
                        'Is a worker who does work for someone else',
                    ],
                    type: 'options',
                    answer: 'Has a duty of care to ensure the health and safety of all workers'
                },
                {
                    id: 7,
                    name: 'In relation to <b>workplace safety<b>, the <b>PCBU<b> has a right to __________.',
                    subtitle: 'Tick (✓) the correct option. There is one (1) correct answer.',
                    options: [
                        'Request workers to follow any reasonable policies or procedures that relate to workplace safety',
                        'Require workers to purchase their own PPE',
                        'Address hazards only if it doesn’t cost anything',
                        'All of the above',
                    ],
                    type: 'options',
                    answer: 'Request workers to follow any reasonable policies or procedures that relate to workplace safety'
                },
                {
                    id: 8,
                    name: 'In relation to <b>workplace safety<b>, a <b>PCBU<b> <b>has a responsibility to<b> __________.',
                    subtitle: 'Tick (✓) the correct options. There are three (3) correct answers.',
                    options: [
                        'Consult with workers on issues that affect them',
                        'Provide safe equipment and systems of work',
                        'Provide a safe and healthy workplace',
                        'Meet with workers at social events outside of work',
                    ],
                    type: 'options',
                    answers: [
                        'Consult with workers on issues that affect them',
                        'Provide safe equipment and systems of work',
                        'Provide a safe and healthy workplace',
                    ]
                },
                {
                    id: 9,
                    name: 'In relation to <b>workplace safety<b>, <b>workers have a right to<b> __________.',
                    subtitle: 'Tick (✓) the correct options. There are four (4) correct answers.',
                    options: [
                        'Be shown how to work safely',
                        'Refuse reasonable directions from their employer',
                        'Speak up about any safety concerns',
                        'Adequate facilities and amenities including first aid equipment',
                        'Say ‘no’ to unsafe work',
                    ],
                    type: 'options',
                    answers: [
                        'Be shown how to work safely',
                        'Speak up about any safety concerns',
                        'Adequate facilities and amenities including first aid equipment',
                        'Say ‘no’ to unsafe work',
                    ]
                },
                {
                    id: 10,
                    name: 'In relation to <b>workplace safety<b>, <b>workers have a responsibility to<b> __________.',
                    partALabel: 'Part A',
                    subtitle: 'Tick (✓) the correct options. There are three (3) correct answers.',
                    partBLabel: 'Part B',
                    partBQuestion: 'Explain why it is important that workers meet their responsibilities on a construction site.',
                    assessorGuideHtml: `<p>Student response should demonstrate a basic understanding that safety is a shared responsibility and following duties under the Act helps prevent incidents.</p><p><b>Example response:</b> Because it helps keep everyone safe and stops incidents from happening.</p>`,
                    options: [
                        'Take reasonable care to avoid harming themselves or others',
                        'Do whatever they are told by their supervisor regardless of whether it is safe',
                        'Report any unsafe situations and hazards to their immediate supervisor',
                        'Ensure they are fit and healthy to attend work',
                    ],
                    type: 'options',
                    answers: [
                        'Take reasonable care to avoid harming themselves or others',
                        'Report any unsafe situations and hazards to their immediate supervisor',
                        'Ensure they are fit and healthy to attend work',
                    ]
                },
                {
                    id: 11,
                    name: 'The following <b>safe work practices<b> should be followed on a construction site.',
                    subtitle: 'Tick (✓) the correct options. There are three (3) correct answers.',
                    options: [
                        'Keeping the work area clean, and placing rubbish in designated areas',
                        'Washing your hands after you use the toilet',
                        'Using drugs to keep you awake when you are tired',
                        'Selecting and using required personal protective equipment',
                    ],
                    type: 'options',
                    answers: [
                        'Keeping the work area clean, and placing rubbish in designated areas',
                        'Washing your hands after you use the toilet',
                        'Selecting and using required personal protective equipment',
                    ]
                },
                {
                    id: 12,
                    name: 'If you need to <b>smoke<b> while at work, you should __________.',
                    subtitle: 'Tick (✓) the correct option. There is one (1) correct answer.',
                    options: [
                        'Dispose of cigarettes on the floor',
                        'Smoke near a window if you can',
                        'Smoke only in designated areas',
                        'Smoke at least 100 metres away from others',
                    ],
                    type: 'options',
                    answer: 'Smoke only in designated areas'
                },
                {
                    id: 13,
                    name: 'What are some ways you can help prevent workplace <b>bullying<b> and <b>harassment<b> at work?',
                    subtitle: 'Tick (✓) the correct options. There are three (3) correct answers.',
                    options: [
                        'Report it if you experience it or witness it',
                        'Follow any relevant policies and procedures',
                        'Don’t get involved in other people’s problems',
                        'Exhibit positive workplace behaviours',
                    ],
                    type: 'options',
                    answers: [
                        'Report it if you experience it or witness it',
                        'Follow any relevant policies and procedures',
                        'Exhibit positive workplace behaviours',
                    ]
                },
                {
                    id: 14,
                    name: '<b>PCBUs<b> have a duty to ensure the following <b>amenities<b> are provided and accessible to workers on site.',
                    subtitle: 'Tick (✓) the correct options. There are three (3) correct answers.',
                    options: [
                        'Toilets',
                        'Food',
                        'Handwashing facilities',
                        'Drinking water',
                    ],
                    type: 'options',
                    answers: [
                        'Toilets',
                        'Handwashing facilities',
                        'Drinking water',
                    ]
                },
                {
                    id: 15,
                    name: 'What are examples of safety documents and procedures that should be followed when performing work tasks and using equipment?',
                    subtitle: 'Tick (✓) the correct options. There are two (2) correct answers.',
                    options: [
                        'Safety Data Sheet',
                        'Safe Work Method Statement',
                        'Annual financial report',
                        'Parts order form',
                    ],
                    type: 'options',
                    answers: [
                        'Safety Data Sheet',
                        'Safe Work Method Statement',
                    ]
                },
                {
                    id: 16,
                    name: 'A <b>‘hazard’<b> is __________.',
                    subtitle: 'Tick (✓) the correct option. There is one (1) correct answer.',
                    options: [
                        'A situation or thing that has the potential to harm a person',
                        'A team of workers that respond to emergencies',
                        'The obligation to protect workers',
                        'A form that is completed when a person is injured',
                    ],
                    type: 'options',
                    answer: 'A situation or thing that has the potential to harm a person'
                },
                {
                    id: 17,
                    name: 'A <b>‘risk’<b> is __________.',
                    subtitle: 'Tick (✓) the correct option. There is one (1) correct answer.',
                    options: [
                        'Two or more hazards',
                        'The duty to act in a way that does not put others at risk of potential harm',
                        'The obligation to protect workers',
                        'The possibility that harm (death, injury or illness) might occur when exposed to a hazard',
                    ],
                    type: 'options',
                    answer: 'The possibility that harm (death, injury or illness) might occur when exposed to a hazard'
                },
                {
                    id: 18,
                    name: 'According to the basic principles of <b>risk management<b>, what <b>five steps<b>, in order, would you take to <b>manage risk<b>?',
                    subtitle: 'Tick (✓) the correct option. There is one (1) correct answer.',
                    options: [
                        'Identify hazard, report, review, control hazard, assess risk',
                        'Assess risk, consult, control risk, identify hazard, review',
                        'Identify hazard, assess risk, consult and report, control hazard, review',
                        'Consult, assess risk, identify hazard, control hazard, review',
                    ],
                    type: 'options',
                    answer: 'Identify hazard, assess risk, consult and report, control hazard, review'
                },
                {
                    id: 19,
                    name: 'A <b>risk matrix<b> can be used to <b>assess risk<b> by rating __________.',
                    subtitle: 'Tick (✓) the correct option. There is one (1) correct answer.',
                    options: [
                        'The consequences of not controlling the risk',
                        'The cost of control measures',
                        'The likelihood and the consequence of a risk occurring',
                        'The time it takes to implement an action',
                    ],
                    type: 'options',
                    answer: 'The likelihood and the consequence of a risk occurring'
                },
                {
                    id: 20,
                    name: 'When <b>controlling a risk<b>, you must attempt to do what first?',
                    subtitle: 'Tick (✓) the correct option. There is one (1) correct answer.',
                    options: [
                        'Minimise the risk',
                        'Eliminate the risk',
                        'Provide workers with PPE',
                        'Install safety signs',
                    ],
                    type: 'options',
                    answer: 'Eliminate the risk'
                },
                {
                    id: 21,
                    name: 'When must a risk <b>control<b> measure be <b>reviewed<b>?',
                    subtitle: 'Tick (✓) the correct options. There are three (3) correct answers.',
                    options: [
                        'When the results of monitoring show the control measure does not control the risk',
                        'When a health and safety representative requests the review as outlined in the legislation',
                        'Every week',
                        'Where an incident occurs because the risk is not adequately controlled',
                    ],
                    type: 'options',
                    answers: [
                        'When the results of monitoring show the control measure does not control the risk',
                        'When a health and safety representative requests the review as outlined in the legislation',
                        'Where an incident occurs because the risk is not adequately controlled',
                    ]
                },
                {
                    id: 22,
                    name: 'It can be assumed that <b>asbestos<b> or <b>asbestos containing material (ACM)<b> are <b>not<b> present in a building or its fixtures where it was __________.',
                    subtitle: 'Tick (✓) the correct option. There is one (1) correct answer.',
                    excludeFromStudentAutoReview: true,
                    options: [
                        'Constructed after 1980 and there is no plant or equipment made before 31 December 1993',
                        'Constructed after 1990 and there is no plant or equipment made before 31 December 2003.',
                        'Constructed after 1960 and there is no plant or equipment made before 31 December 1973.',
                        'Constructed after 1970 and there is no plant or equipment made before 31 December 1983.',
                    ],
                    type: 'options',
                    answer: 'Constructed after 1990 and there is no plant or equipment made before 31 December 2003.'
                },
                {
                    id: 23,
                    name: 'In older-style buildings, <b>asbestos<b> is commonly found in the following locations.',
                    subtitle: 'Tick (✓) the correct options. There are three (3) correct answers.',
                    options: [
                        'Vinyl floor tiles',
                        '‘Super six’ roofing',
                        'Roller doors',
                        'Walls and ceilings',
                    ],
                    type: 'options',
                    answers: [
                        'Vinyl floor tiles',
                        '‘Super six’ roofing',
                        'Walls and ceilings',
                    ]
                },
                {
                    id: 24,
                    name: 'Which of the following procedures must be undertaken before a worker enters a <b>confined space<b>?',
                    partALabel: 'Part A',
                    subtitle: 'Tick (✓) the correct options. There are three (3) correct answers.',
                    partBLabel: 'Part B',
                    partBQuestion: 'Explain why these safe work practices are important before entering a confined space.',
                    assessorGuideHtml: `<p>Student response should demonstrate a basic understanding of why these safe work practices are implemented before entering a confined space.</p><p><b>Example response:</b> To make sure workers are safe by identifying hazards, ensuring workers are trained and the confined space is entered only when it is safe to do so.</p>`,
                    options: [
                        'Erect a blue sign next to the confined space',
                        'Conduct a written risk assessment',
                        'Undertake confined space training',
                        'Perform gas testing',
                    ],
                    type: 'options',
                    answers: [
                        'Conduct a written risk assessment',
                        'Undertake confined space training',
                        'Perform gas testing',
                    ]
                },
                {
                    id: 25,
                    name: 'What <b>control measures<b> can be used to minimise the risk when working in a <b>trench over 1.5m deep<b>?',
                    partALabel: 'Part A',
                    subtitle: 'Tick (✓) the correct option. There are three (3) correct answers.',
                    partBLabel: 'Part B',
                    partBQuestion: 'Explain why these types of risk controls for trenches should be used.',
                    assessorGuideHtml: `<p>Student response should show a basic understanding of why these safe excavation work practices are used.</p><p><b>Example response:</b> Because the sides can collapse and bury someone. The controls stop that from happening and keep workers safe.</p>`,
                    options: [
                        'Shoring',
                        'Entry permit',
                        'Benching',
                        'Battering',
                    ],
                    type: 'options',
                    answers: [
                        'Shoring',
                        'Benching',
                        'Battering',
                    ]
                },
                {
                    id: 26,
                    name: 'If you found an <b>electrical<b> power tool with a damaged lead on site, how would you deal with this hazard?',
                    partALabel: 'Part A',
                    subtitle: 'Tick (✓) the correct options. There are three (3) correct answers.',
                    partBLabel: 'Part B',
                    partBQuestion: 'Explain why it is important to follow these steps when you find damaged electrical equipment on site.',
                    assessorGuideHtml: `<p>Student response should show a basic understanding of electrical safety risks and the importance of proper reporting and tagging procedures.</p><p><b>Example response:</b> So no one gets electrocuted when using it, and the supervisor knows to fix it.</p>`,
                    options: [
                        'Report the damage to your supervisor',
                        'Leave it where it is',
                        'Remove it from use',
                        'Place an ‘out of service’ tag on it',
                    ],
                    type: 'options',
                    answers: [
                        'Report the damage to your supervisor',
                        'Remove it from use',
                        'Place an ‘out of service’ tag on it',
                    ]
                },
                {
                    id: 27,
                    name: 'What <b>underground service hazards<b> should you be aware of when undertaking <b>excavation work<b>?',
                    subtitle: 'Tick (✓) the correct options. There are four (4) correct answers.',
                    options: [
                        'Electricity',
                        'Traffic control',
                        'Water',
                        'Gas',
                        'Telecommunications (e.g. NBN)',
                    ],
                    type: 'options',
                    answers: [
                        'Electricity',
                        'Water',
                        'Gas',
                        'Telecommunications (e.g. NBN)',
                    ]
                },
                {
                    id: 28,
                    name: 'What can be used to warn of <b>overhead electric power lines<b> near a construction site?',
                    subtitle: 'Tick (✓) the correct option. There are two (2) correct answers.',
                    options: [
                        'Coloured markers (e.g. Orange balls or flags / Tiger tails)',
                        'Traffic control signage',
                        'Speed limit signage',
                        'Warning / Danger signage.',
                    ],
                    type: 'options',
                    answers: [
                        'Coloured markers (e.g. Orange balls or flags / Tiger tails)',
                        'Warning / Danger signage.',
                    ]
                },
                {
                    id: 29,
                    name: 'Silica <b>dust<b> can be generated by which construction activities?',
                    subtitle: 'Tick (✓) the correct option. There are three (3) correct answers.',
                    options: [
                        'Cutting bricks',
                        'Polishing concrete',
                        'Sawing fibre-cement sheeting',
                        'Erecting scaffold',
                    ],
                    type: 'options',
                    answers: [
                        'Cutting bricks',
                        'Polishing concrete',
                        'Sawing fibre-cement sheeting',
                    ]
                },
                {
                    id: 30,
                    name: 'What <b>control measures<b> can be used to protect workers and members of the public from <b>falling objects<b> from a construction site?',
                    subtitle: 'Tick (✓) the correct options. There are three (3) correct answers.',
                    options: [
                        'Umbrella',
                        'Overhead gantry',
                        'Catch platform',
                        'Perimeter containment screening',
                    ],
                    type: 'options',
                    answers: [
                        'Overhead gantry',
                        'Catch platform',
                        'Perimeter containment screening',
                    ]
                },
                {
                    id: 31,
                    name: 'What information about <b>hazardous chemicals<b> and/or <b>dangerous goods<b> would you find in a Safety Data Sheet (SDS)?',
                    subtitle: 'Tick (✓) the correct options. There are three (3) correct answers.',
                    options: [
                        'The identity of the chemical product and its ingredients',
                        'What to do in the event of an emergency or spill involving the chemical',
                        'A register of all chemicals in the workplace',
                        'Safe handling and storage procedures for the chemical',
                    ],
                    type: 'options',
                    answers: [
                        'The identity of the chemical product and its ingredients',
                        'What to do in the event of an emergency or spill involving the chemical',
                        'Safe handling and storage procedures for the chemical',
                    ]
                },
                {
                    id: 32,
                    name: 'What are some ways you can <b>reduce<b> your risk of <b>heat stress<b> at work?',
                    subtitle: 'Tick (✓) the correct options. There are three (3) correct answers.',
                    options: [
                        'Work in shaded areas',
                        'Take rest breaks in a cool place',
                        'Work outside in the middle of the day',
                        'Stay hydrated',
                    ],
                    type: 'options',
                    answers: [
                        'Work in shaded areas',
                        'Take rest breaks in a cool place',
                        'Stay hydrated',
                    ]
                },
                {
                    id: 33,
                    name: 'What <b>environmental hazards<b> might a worker <b>working outside<b> be exposed to?',
                    subtitle: 'Tick (✓) the correct options. There are three (3) correct answers.',
                    options: [
                        'Confined spaces',
                        'Sun exposure',
                        'Extreme cold',
                        'Dangerous animals',
                    ],
                    type: 'options',
                    answers: [
                        'Sun exposure',
                        'Extreme cold',
                        'Dangerous animals',
                    ]
                },
                {
                    id: 34,
                    name: 'When identifying if a <b>manual task<b> may be hazardous, what risk factors should you consider?',
                    subtitle: 'Tick (✓) the correct options. There are three (3) correct answers.',
                    excludeFromStudentAutoReview: true,
                    options: [
                        'Inactivity',
                        'Vibration',
                        'Weight',
                        'Awkward or sustained postures',
                    ],
                    type: 'options',
                    answers: [
                        'Vibration',
                        'Weight',
                        'Awkward or sustained postures',
                    ]
                },
                {
                    id: 35,
                    name: 'How can you reduce the risk of <b>hearing damage<b> at work?',
                    subtitle: 'Tick (✓) the correct options. There are three (3) correct answers.',
                    options: [
                        'Select quieter tools',
                        'Use earmuffs or earplugs',
                        'Stay out of noisy areas when not directly involved in the work being done',
                        'Play music loudly on headphones to block out the construction noise',
                    ],
                    type: 'options',
                    answers: [
                        'Select quieter tools',
                        'Use earmuffs or earplugs',
                        'Stay out of noisy areas when not directly involved in the work being done',
                    ]
                },
                {
                    id: 36,
                    name: 'How many points of contact must you maintain when climbing a <b>ladder<b>?',
                    subtitle: 'Tick (✓) the correct option. There is one (1) correct answer.',
                    options: [
                        '1',
                        '2',
                        '3',
                        '4',
                    ],
                    type: 'options',
                    answer: '3'
                },
                {
                    id: 37,
                    name: 'Engineering controls are required for <b>residential construction<b> work where there is a <b>risk of falling from over what height<b>?',
                    subtitle: 'Tick (✓) the correct option. There is one (1) correct answer.',
                    options: [
                        '3 metres',
                        '2 metres',
                        '5 metres',
                        '6 metres',
                    ],
                    type: 'options',
                    answer: '3 metres'
                },
                {
                    id: 38,
                    name: 'Engineering controls are required for <b>construction work,<b> other than residential construction work where there is a <b>risk of falling from over what height<b>?',
                    subtitle: 'Tick (✓) the correct option. There is one (1) correct answer.',
                    options: [
                        '2 metres',
                        '3 metres',
                        '6 metres',
                        '5 metres',
                    ],
                    type: 'options',
                    answer: '2 metres'
                },
                {
                    id: 39,
                    name: 'What <b>engineering control measures<b> can be used to minimise the risk of death or injury if a fall occurs when <b>working at height<b>?',
                    subtitle: 'Tick (✓) the correct options. There are three (3) correct answers.',
                    options: [
                        'Edge protection',
                        'Travel restraint system',
                        'Fall-arresting platform',
                        'Bungee cord',
                    ],
                    type: 'options',
                    answers: [
                        'Edge protection',
                        'Travel restraint system',
                        'Fall-arresting platform',
                    ]
                },
                {
                    id: 40,
                    name: 'What work activities are considered <b>high risk construction work<b> and require the preparation of a <b>safe work method statement (SWMS)<b>?',
                    subtitle: 'Tick (✓) the correct options. There are three (3) correct answers.',
                    options: [
                        'Work carried out in an area where there is movement of powered mobile plant',
                        'Work involving a risk of a person falling more than 2 metres',
                        'Work from a 1.4 metre aluminium mobile scaffold',
                        'Work involving tilt-up or precast concrete',
                    ],
                    type: 'options',
                    answers: [
                        'Work carried out in an area where there is movement of powered mobile plant',
                        'Work involving a risk of a person falling more than 2 metres',
                        'Work involving tilt-up or precast concrete',
                    ]
                },
                {
                    id: 41,
                    name: 'Which of the following tasks and equipment require a <b>high risk work licence<b>?',
                    subtitle: 'Tick (✓) the correct options. There are three (3) correct answers.',
                    options: [
                        'Cranes',
                        'Dogging, rigging and scaffolding',
                        'Electrical and plumbing',
                        'Forklifts, hoists and reach stackers',
                    ],
                    type: 'options',
                    answers: [
                        'Cranes',
                        'Dogging, rigging and scaffolding',
                        'Forklifts, hoists and reach stackers',
                    ]
                },
                {
                    id: 42,
                    name: 'What <b>construction incidents<b> need to be <b>reported<b> to Workplace Health and Safety Queensland (WHSQ) by a PCBU immediately after becoming aware of them?',
                    subtitle: 'Tick (✓) the correct options. There are three (3) correct answers.',
                    options: [
                        'Incidents requiring on-site first aid',
                        'A serious injury or illness of a person',
                        'A dangerous incident',
                        'A death of a person',
                    ],
                    type: 'options',
                    answers: [
                        'A serious injury or illness of a person',
                        'A dangerous incident',
                        'A death of a person',
                    ]
                },
                {
                    id: 43,
                    name: '‘Near misses’ or ‘dangerous occurrences’, are construction incidents that may pose an immediate and significant risk to people or property and should __________.',
                    subtitle: 'Tick (✓) the correct option. There is one (1) correct answer.',
                    options: [
                        'Be considered a normal event requiring no further action',
                        'Not be reported to anyone unless it has happened before',
                        'Be reported to your supervisor so action can be taken to prevent recurrence',
                        'Not be reported to your supervisor because there is no actual personal injury or property damage',
                    ],
                    type: 'options',
                    answer: 'Be reported to your supervisor so action can be taken to prevent recurrence'
                },
                {
                    id: 44,
                    name: 'A PCBU must ensure that an <b>emergency plan<b> is in place for the workplace. The emergency plan must provide __________.',
                    subtitle: 'Tick (✓) the correct options. There are three (3) correct answers.',
                    options: [
                        'Information, training and instruction for workers about emergency procedures',
                        'Emergency evacuation procedures',
                        'Procedures for medical treatment and assistance',
                        'Information about all hazards at the workplace',
                    ],
                    type: 'options',
                    answers: [
                        'Information, training and instruction for workers about emergency procedures',
                        'Emergency evacuation procedures',
                        'Procedures for medical treatment and assistance',
                    ]
                },
                {
                    id: 45,
                    name: 'What events are considered <b>construction emergencies<b> and may require workers to be <b>emergency evacuated<b> from site?',
                    subtitle: 'Tick (✓) the correct options. There are four (4) correct answers.',
                    options: [
                        'Structural collapse',
                        'Chemical spill',
                        'A worker feeling unwell',
                        'Toxic or flammable vapour emission',
                        'Vehicle or mobile plant accident',
                    ],
                    type: 'options',
                    answers: [
                        'Structural collapse',
                        'Chemical spill',
                        'Toxic or flammable vapour emission',
                        'Vehicle or mobile plant accident',
                    ]
                },
                {
                    id: 46,
                    name: 'In responding to a <b>fire<b> on site, the following steps should be undertaken __________.',
                    subtitle: 'Tick (✓) the correct options. There are three (3) correct answers.',
                    options: [
                        'Continue working until it’s close enough to be of concern',
                        'Remove people from the area',
                        'Alert emergency services',
                        'Try to confine the fire if possible and use fire safety equipment to extinguish where safe to do so',
                    ],
                    type: 'options',
                    answers: [
                        'Remove people from the area',
                        'Alert emergency services',
                        'Try to confine the fire if possible and use fire safety equipment to extinguish where safe to do so',
                    ]
                },
                {
                    id: 47,
                    name: 'As part of your site induction, you should be provided with the following information about <b>first aid<b>.',
                    subtitle: 'Tick (✓) the correct options. There are three (3) correct answers.',
                    options: [
                        'The procedures to be followed when first aid is required',
                        'The names and locations of people trained to administer first aid',
                        'How to perform first aid on an injured person',
                        'The location of first aid equipment and facilities',
                    ],
                    type: 'options',
                    answers: [
                        'The procedures to be followed when first aid is required',
                        'The names and locations of people trained to administer first aid',
                        'The location of first aid equipment and facilities',
                    ]
                },
                {
                    id: 48,
                    name: 'What is the <b>purpose<b> of a <b>danger tag<b>?',
                    subtitle: 'Tick (✓) the correct option. There is one (1) correct answer.',
                    img: '/qld-assessment/q48-danger-tag.png',
                    imgAlt: 'Danger tag example',
                    imgWidth: '192px',
                    imgMaxWidth: '192px',
                    options: [
                        'To tell workers not to operate plant or equipment',
                        'To tell workers that plant or equipment is safe to use',
                        'It shows that only your supervisor can operate the plant or equipment',
                        'To allow you to operate the plant or equipment in an emergency',
                    ],
                    type: 'options',
                    answer: 'To tell workers not to operate plant or equipment'
                },
                {
                    id: 49,
                    name: 'An <b>out of service tag<b> is used to identify equipment or machinery which is __________, and it must only be removed by __________.',
                    subtitle: 'Tick (✓) the correct option. There is one (1) correct answer.',
                    img: '/qld-assessment/q49-out-of-service-tag.jpg',
                    imgAlt: 'Out of service tag example',
                    imgWidth: '140px',
                    imgMaxWidth: '140px',
                    options: [
                        'Faulty / a competent person',
                        'Safe to use / the boss',
                        'Safe to use / a high risk work licence holder',
                        'Faulty / the person who attached the tag',
                    ],
                    type: 'options',
                    answer: 'Faulty / a competent person'
                },
                {
                    id: 50,
                    name: 'Which of the following <b>site conditions or practices<b> could increase the risk of an <b>unplanned collapse or structural failure<b> on a construction site?',
                    subtitle: 'Tick (✓) the correct options. There are three (3) correct answers.',
                    options: [
                        'Operating plant and equipment near recently excavated or soft ground',
                        'Using a hoist or crane and exceeding its working load limit (WLL)',
                        'Delivery vehicle entering site without a traffic controller',
                        'Using unrated formwork props during a concrete slab pour',
                        'Stopping work to grab a drink',
                    ],
                    type: 'options',
                    answers: [
                        'Operating plant and equipment near recently excavated or soft ground',
                        'Using a hoist or crane and exceeding its working load limit (WLL)',
                        'Using unrated formwork props during a concrete slab pour',
                    ]
                },
                {
                    id: 51,
                    name: 'The table below shows a range of <b>Personal Protective Equipment (PPE)<b>. For each item, identify what type of PPE it is, list one (1) hazard the PPE is designed to protect against, and explain its correct use on a construction site.',
                    type: 'imageTableForm',
                    tableHeaderTextAlign: 'center',
                    tableHeaderBackgroundColor: '#f1f1f1',
                    disableTextareaResize: true,
                    assessorMarkPerRow: true,
                    textAnswer: true,
                    assessorCommentField: 'Assessor Comments if applicable 1',
                    assessorGuideIntro: 'Assessors should use professional judgement. Possible acceptable responses include:',
                    assessorGuideTable: {
                        header: ['PPE', 'Type / PPE Name', 'Hazard', 'Correct Usage Requirements'],
                        body: [
                            {
                                image: '/qld-assessment/q51-ppe-2.png',
                                alt: 'Work gloves',
                                cells: [
                                    'Gloves',
                                    'Handling sharp or rough objects',
                                    'Must be the correct type, for example nitrile for chemicals or leather for rough materials.',
                                ],
                            },
                            {
                                image: '/qld-assessment/q51-ppe-1.png',
                                alt: 'Safety boots',
                                cells: [
                                    'Safety footwear',
                                    'Dropped objects or ground conditions',
                                    'Must be steel-capped and worn at all times on site.',
                                ],
                            },
                            {
                                image: '/qld-assessment/q51-ppe-3.png',
                                alt: 'Safety harness',
                                cells: [
                                    'Fall arrest / restraint harness',
                                    'Falls from height',
                                    'Must be inspected and worn correctly and attached to a suitable anchor point.',
                                ],
                            },
                            {
                                image: '/qld-assessment/q51-ppe-4.png',
                                alt: 'Respirator',
                                cells: [
                                    'Respiratory protection',
                                    'Dust or airborne contaminants',
                                    'Must be inspected and worn correctly.',
                                ],
                            },
                            {
                                image: '/qld-assessment/q51-ppe-5.png',
                                alt: 'Sunscreen',
                                cells: [
                                    'Ultraviolet (UV) protection',
                                    'Sun exposure',
                                    'Should be applied before sun exposure and reapplied every two hours.',
                                ],
                            },
                        ],
                    },
                    table: {
                        header: ['PPE', 'Type / PPE Name', 'Hazard', 'Correct Usage Requirements'],
                        body: [
                            { image: '/qld-assessment/q51-ppe-2.png', alt: 'Work gloves' },
                            { image: '/qld-assessment/q51-ppe-1.png', alt: 'Safety boots' },
                            { image: '/qld-assessment/q51-ppe-3.png', alt: 'Safety harness' },
                            { image: '/qld-assessment/q51-ppe-4.png', alt: 'Respirator' },
                            { image: '/qld-assessment/q51-ppe-5.png', alt: 'Sunscreen' },
                        ]
                    },
                    inputColumns: [
                        { key: 'type', label: 'Type / PPE Name' },
                        { key: 'hazard', label: 'Hazard' },
                        { key: 'usage', label: 'Correct Usage Requirements' },
                    ]
                },
                {
                    id: 52,
                    name: 'The table below contains safety signs and symbols relevant to the construction industry. Identify the type of sign and explain its meaning.',
                    type: 'imageTableForm',
                    tableHeaderTextAlign: 'center',
                    tableHeaderBackgroundColor: '#f1f1f1',
                    disableTextareaResize: true,
                    assessorMarkPerRow: true,
                    textAnswer: true,
                    assessorCommentField: 'Assessor Comments if applicable',
                    assessorGuideIntro: 'Assessors should use professional judgement. Possible acceptable responses include:',
                    assessorGuideTable: {
                        header: ['Sign', 'Type of Sign', 'Meaning of Sign'],
                        body: [
                            {
                                image: '/qld-assessment/q52-sign-1.png',
                                alt: 'No smoking sign',
                                cells: ['Prohibition sign', 'Smoking prohibited / no smoking allowed.'],
                            },
                            {
                                image: '/qld-assessment/q52-sign-2.png',
                                alt: 'Confined space danger sign',
                                cells: ['Danger sign', 'Potentially life-threatening hazard - confined space / must not enter without a permit.'],
                            },
                            {
                                image: '/qld-assessment/q52-sign-3.png',
                                alt: '10 speed limit sign',
                                cells: ['Limitation sign', 'Speed limit of 10 km/h.'],
                            },
                            {
                                image: '/qld-assessment/q52-sign-4.png',
                                alt: 'Beware of vehicles warning sign',
                                cells: ['Warning sign', 'Vehicle hazard / look out for moving vehicles in the area.'],
                            },
                            {
                                image: '/qld-assessment/q52-sign-5.png',
                                alt: 'Fire extinguisher sign',
                                cells: ['Fire sign', 'Shows location of fire extinguisher.'],
                            },
                            {
                                image: '/qld-assessment/q52-sign-6.png',
                                alt: 'Fire alarm sign',
                                cells: ['Fire sign', 'Shows location of fire alarm.'],
                            },
                            {
                                image: '/qld-assessment/q52-sign-7.png',
                                alt: 'Emergency eye wash sign',
                                cells: ['Emergency sign', 'Shows location of emergency eye wash.'],
                            },
                            {
                                image: '/qld-assessment/q52-sign-10.png',
                                alt: 'Emergency exit sign',
                                cells: ['Emergency sign', 'Shows location of emergency exit.'],
                            },
                            {
                                image: '/qld-assessment/q52-sign-8.png',
                                alt: 'Light duty scaffold sign',
                                cells: ['Warning sign', 'Maximum weight that can be safely supported.'],
                            },
                            {
                                image: '/qld-assessment/q52-sign-9.png',
                                alt: 'Noise level caution sign',
                                cells: ['Caution sign', 'High noise levels, hearing protection required.'],
                            },
                        ],
                    },
                    table: {
                        header: ['Sign', 'Type of Sign', 'Meaning of Sign'],
                        body: [
                            { image: '/qld-assessment/q52-sign-1.png', alt: 'No smoking sign' },
                            { image: '/qld-assessment/q52-sign-2.png', alt: 'Confined space danger sign' },
                            { image: '/qld-assessment/q52-sign-3.png', alt: '10 speed limit sign' },
                            { image: '/qld-assessment/q52-sign-4.png', alt: 'Beware of vehicles warning sign' },
                            { image: '/qld-assessment/q52-sign-5.png', alt: 'Fire extinguisher sign' },
                            { image: '/qld-assessment/q52-sign-6.png', alt: 'Fire alarm sign' },
                            { image: '/qld-assessment/q52-sign-7.png', alt: 'Emergency eye wash sign' },
                            { image: '/qld-assessment/q52-sign-10.png', alt: 'Emergency exit sign' },
                            { image: '/qld-assessment/q52-sign-8.png', alt: 'Light duty scaffold sign' },
                            { image: '/qld-assessment/q52-sign-9.png', alt: 'Noise level caution sign' },
                        ]
                    },
                    inputColumns: [
                        { key: 'type', label: 'Type of Sign' },
                        { key: 'meaning', label: 'Meaning of Sign' },
                    ]
                },
            ];

export default qldAssessmentQuestions;
